export default __webpack_public_path__ + "static/media/edital2.c57513fe.png";